import React from 'react';
import { useDispatch } from 'react-redux';
import { getGarageEmailAddress } from 'helpers/garage';
import { openModal } from 'src/redux/configurator/actions';
import useSaveToGarage from './useSaveToGarage';

const useLaunchSendToDealer = () => {
  const dispatch = useDispatch();
  const saveToGarage = useSaveToGarage();

  const launchSendToDealer = () => {
    if (getGarageEmailAddress()) {
      saveToGarage();
      dispatch(openModal('sendToDealer'));
    } else {
      dispatch(
        openModal('saveToGarage', {
          afterSave: () => dispatch(openModal('sendToDealer')),
        })
      );
    }
  };

  return launchSendToDealer;
};

export default useLaunchSendToDealer;
